import { UserRole } from 'models/User'

export const laborUser = (user: any) => ({
  ...user,
  punch_cards_count: user.stats.active_punch_cards_count,
  active_strikes_count: user.stats.active_strikes_count,
  role: UserRole.UPSHIFTER,
  status: Number(user.status),
})

export const employeeUser = (user: any) => ({
  ...user,
  business_id: user.employer_business_id,
  role: user.roles[0].name,
})

export const businessUser = (user: any) => ({
  ...user,
  role: UserRole.BUSINESS,
})
